import type { ISerialize } from '@/objects/ISerialize';

export class GuidArray implements ISerialize {
    public Values: string[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Values?: string[] }) {
        this.Values = values.Values ?? [];
    }

    public serialize(): string {
        return '{' + `"Values": [ ${this.Values.map((x) => JSON.stringify(x))} ]` + '}';
    }

    /**
     * Creates an instance of GuidArray from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Values?: string[] }): GuidArray {
        return new GuidArray(values);
    }

    public static _FromServerJson(json: any): GuidArray {
        return new GuidArray({ Values: json.Values });
    }

    /**
     * Creates an instance of GuidArray from another instance of GuidArray.
     * @param other The GuidArray you want to clone
     * @returns A cloned GuidArray
     */
    public static FromOther(other: GuidArray): GuidArray {
        return GuidArray._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return GuidArray.FromOther(this);
    }

    static NAME_OF_CLASS = 'GuidArray';
}
